import styled from 'styled-components';

export const LabelV2 = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #18233A;
  margin-bottom: 6px;
  display: block;
  letter-spacing: -0.1px;
`;